import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { DataSnackBar, SnackBarTheme } from '../../models/snackbar-data';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-generic-snack-bar',
    templateUrl: './generic-snack-bar.component.html',
    styleUrls: ['./generic-snack-bar.component.scss'],
    imports: [MatIcon, MatTooltip]
})
export class GenericSnackBarComponent {
  constructor(
    public snackBarRef: MatSnackBarRef<GenericSnackBarComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public data: DataSnackBar
  ) { }

  get snackBarIconTypes() {
    return SnackBarTheme;
  }

}
